import { render, staticRenderFns } from "./NavFooter.vue?vue&type=template&id=33c7099e&scoped=true&"
import script from "./NavFooter.vue?vue&type=script&lang=ts&"
export * from "./NavFooter.vue?vue&type=script&lang=ts&"
import style0 from "./NavFooter.vue?vue&type=style&index=0&id=33c7099e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c7099e",
  null
  
)

export default component.exports